import AuthenticatedPopupLayout from "../../layouts/authenticated-popup";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { Form, Input, Button, message } from "antd";
import React, { useRef, useEffect, useMemo, useState } from "react";
import FlexCard from "../../components/flex-card";
import { useTranslation } from "react-i18next";
import unwrapAxiosPromise from "../../util/unwrapAxiosPromise";
import axios from "axios";
import passos from "./passos/passos";

export default function UsoModeloPage() {
  const { t } = useTranslation();
  const [passo, setPasso] = useState(1);
  const [arquivo, setArquivo] = useState(1);
  const [modeloSelecionado, setModeloSelecionado] = useState(null);
  const [docxBlob, setDocxBlob] = useState(null);

  const [form] = Form.useForm();

  const handleAvancar = async () => {
    await form.validateFields();
    const formValues = form.getFieldsValue();
    const payload = {
      id: modeloSelecionado.id,
      campos: modeloSelecionado.campos.map((campo) => ({
        campo,
        value: formValues[campo] || "",
      })),
    };
    const data = await unwrapAxiosPromise(axios.post("/modelos/personalizado", payload));

    const blob = await unwrapAxiosPromise(axios.get(`${window.location.origin}${data.url}`, { responseType: "blob" }));
    setDocxBlob(blob);

    setArquivo(data);
    setPasso(4);
  };

  const handleFirstDoc = async () => {
    const blob = await unwrapAxiosPromise(axios.get(`${window.location.origin}${modeloSelecionado.anexo.url}`, { responseType: "blob" }));
    setDocxBlob(blob);
  };

  const sendBinario = async (nameFile) => {
    const blob = await unwrapAxiosPromise(
      axios.get(`${window.location.origin}${arquivo.url}`, {
        responseType: "blob",
      })
    );
    const arquivoComNomeNovo = new File([blob], `${nameFile}.docx`, {
      type: blob.type,
    });

    if (window.opener) {
      window.opener.postMessage(
        {
          tipo: "ARQUIVO_RENOMEADO",
          conteudo: arquivoComNomeNovo,
        },
        "*"
      );
      window.close();
    }
  };

  const handleRenomearArquivo = async () => {
    await form.validateFields();
    const nameFile = form.getFieldValue("nameFile");
    sendBinario(nameFile);
  };

  return (
    <AuthenticatedPopupLayout>
      <FlexCard>
        <div style={{ display: "flex", flexDirection: "column", minHeight: "100%", height: "100%" }}>
          <div style={{ flexGrow: 1 }}>{passos(passo, docxBlob, setModeloSelecionado, modeloSelecionado, form)}</div>
          <div
            style={{
              background: "#fff",
              paddingTop: "16px",
              paddingBottom: "16px",
              display: "flex",
              justifyContent: "flex-end",
              gap: "12px",
              borderTop: "2px solid #eee",
            }}
          >
            <Button icon={<LeftOutlined />} onClick={() => setPasso((prev) => Math.max(1, prev - 1))} disabled={passo === 1}>
              {t("Voltar")}
            </Button>
            <Button
              type="primary"
              icon={<RightOutlined />}
              onClick={() => {
                if (passo === 1) {
                  if (!modeloSelecionado) {
                    message.warning("Selecione um modelo antes de avançar.");
                    return;
                  }
                  setPasso(2);
                  handleFirstDoc();
                } else if (passo === 2) {
                  setPasso(3);
                } else if (passo === 3) {
                  handleAvancar();
                } else if (passo === 4) {
                  setPasso(5);
                } else if (passo == 5) {
                  handleRenomearArquivo();
                }
              }}
            >
              {passo === 4 ? t("Confirmar") : t("Avançar")}
            </Button>
          </div>
        </div>
      </FlexCard>
    </AuthenticatedPopupLayout>
  );
}
